import { type LucideProps } from 'lucide-react'

export default function Apify(props: LucideProps) {
  return (
    <svg viewBox='0 0 131.8 135.3' fill='none' {...props}>
      <g>
        <path
          d='M16.6,12.6C6,14.1-1.3,23.8,0.2,34.3l11.4,81.2L59.3,6.6L16.6,12.6z'
          fill='currentColor'
        ></path>
        <path
          d='M131.8,80.2l-4.5-62.4c-0.8-10.6-10-18.5-20.5-17.8c-0.4,0-0.9,0.1-1.3,0.1L87.1,2.7l40.5,90.9C130.6,89.9,132.1,85.1,131.8,80.2z'
          fill='currentColor'
        ></path>
        <path
          d='M28.9,135.2c3.3,0.4,6.6-0.1,9.6-1.4l69.5-29.4L75,30.2L28.9,135.2z'
          fill='currentColor'
        ></path>
      </g>
    </svg>
  )
}
